/**
 * Modal for renaming an image
 */
export class RenameModal {
    constructor() {
        this.modal = null;
        this.input = null;
        this.onConfirm = null;
        this.createElement();
    }

    /**
     * Create the modal DOM element
     */
    createElement() {
        // Create backdrop
        this.modal = document.createElement('div');
        this.modal.id = 'rename-modal';
        this.modal.className = 'fixed inset-0 bg-black/70 backdrop-blur-sm z-[1003] hidden flex items-center justify-center';

        // Create modal content
        const modalContent = document.createElement('div');
        modalContent.className = 'bg-slate-800 rounded-xl shadow-2xl p-6 w-full max-w-md border border-slate-700';

        // Title
        const title = document.createElement('h3');
        title.className = 'text-xl font-semibold text-white mb-4';
        title.textContent = 'Renommer l\'image';

        // Input
        this.input = document.createElement('input');
        this.input.type = 'text';
        this.input.className = 'w-full px-4 py-2 bg-slate-900 border border-slate-600 rounded-lg text-white placeholder-slate-400 focus:outline-none focus:border-blue-500 focus:ring-2 focus:ring-blue-500/50 mb-6';
        this.input.placeholder = 'Nouveau nom...';

        // Buttons container
        const buttonsContainer = document.createElement('div');
        buttonsContainer.className = 'flex gap-3 justify-end';

        // Cancel button
        const cancelBtn = document.createElement('button');
        cancelBtn.className = 'px-4 py-2 bg-slate-700 hover:bg-slate-600 text-white rounded-lg transition-colors';
        cancelBtn.textContent = 'Annuler';
        cancelBtn.addEventListener('click', () => this.hide());

        // Confirm button
        const confirmBtn = document.createElement('button');
        confirmBtn.className = 'px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg transition-colors';
        confirmBtn.textContent = 'Valider';
        confirmBtn.addEventListener('click', () => this.handleConfirm());

        buttonsContainer.appendChild(cancelBtn);
        buttonsContainer.appendChild(confirmBtn);

        modalContent.appendChild(title);
        modalContent.appendChild(this.input);
        modalContent.appendChild(buttonsContainer);

        this.modal.appendChild(modalContent);
        document.body.appendChild(this.modal);

        // Handle Enter key
        this.input.addEventListener('keydown', (e) => {
            if (e.key === 'Enter') {
                this.handleConfirm();
            } else if (e.key === 'Escape') {
                this.hide();
            }
        });

        console.log('✅ Rename modal created');
    }

    /**
     * Show the modal
     */
    show(currentName, onConfirm) {
        this.onConfirm = onConfirm;
        this.input.value = currentName;
        this.modal.classList.remove('hidden');

        // Focus input and select text
        setTimeout(() => {
            this.input.focus();
            this.input.select();
        }, 100);

        console.log('📝 Rename modal shown');
    }

    /**
     * Hide the modal
     */
    hide() {
        this.modal.classList.add('hidden');
        this.input.value = '';
        this.onConfirm = null;
        console.log('📝 Rename modal hidden');
    }

    /**
     * Handle confirm action
     */
    handleConfirm() {
        const newName = this.input.value.trim();
        if (newName && this.onConfirm) {
            this.onConfirm(newName);
        }
        this.hide();
    }

    /**
     * Remove the modal from DOM
     */
    dispose() {
        if (this.modal && this.modal.parentNode) {
            this.modal.parentNode.removeChild(this.modal);
            this.modal = null;
            console.log('✅ Rename modal disposed');
        }
    }
}
